module.exports = __webpack_public_path__ + "img/update3.5_image01.e8bd9e0c.png";